import { PUNCTUATION, QUERY_LENGTH_LIMIT, VALID_JOINS } from "../config.js";
import { insertTextAfterSelection } from "../insertTextAfterSelection.js";
import { MentionsFloatingBox } from "../MentionsFloatingBox.js";
import { INSERT_HASHTAG_MENTION } from "./commands.js";
import { isGroupOption } from "./utils.js";
import { HashtagMentionsOptionsDropdown } from "./HashtagMentionsOptionsDropdown.js";
import { HashtagMentionTypeaheadOption } from "./HashtagMentionTypeaheadOption.js";
import { $createHashtagMentionNode } from "./nodes/HashtagMentionNode.js";
import { useHashtagMentionsOptions } from "./useHashtagMentionsOptions.js";
import { c } from "react-compiler-runtime";
import { useLockScroll } from "@adamdotai/design-system";
import { jsx } from "react/jsx-runtime";
import * as React$1 from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createNodeSelection, $setSelection, COMMAND_PRIORITY_CRITICAL, COMMAND_PRIORITY_NORMAL } from "lexical";
import ReactDOM from "react-dom";
import { LexicalTypeaheadMenuPlugin } from "@lexical/react/LexicalTypeaheadMenuPlugin";

//#region src/plugins/MentionsPlugin/HashtagMentionsPlugin/HashtagMentionsPlugin.tsx
const VALID_CHARS = `[^#${PUNCTUATION}\\s]`;
const hashtagMentionRegex = new RegExp(`(^|\\s|\\()([#]((?:${VALID_CHARS}${VALID_JOINS}){0,${QUERY_LENGTH_LIMIT}}))$`);
const getMaybeQueryMatch = (text) => {
	const match = hashtagMentionRegex.exec(text);
	if (match == null) return null;
	const [, maybeLeadingWhitespace, replaceableString, matchingString] = match;
	return {
		leadOffset: match.index + maybeLeadingWhitespace.length,
		matchingString,
		replaceableString
	};
};
const HashtagMentionsPlugin = () => {
	const $ = c(17);
	let t0;
	if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
		t0 = { targetId: "content-space-area" };
		$[0] = t0;
	} else t0 = $[0];
	const { lockScroll, unLockScroll } = useLockScroll(t0);
	const [editor] = useLexicalComposerContext();
	const [query, setQuery] = React$1.useState("");
	const { options } = useHashtagMentionsOptions(query ?? "");
	let t1;
	let t2;
	if ($[1] !== options) {
		t2 = options.map(_temp);
		$[1] = options;
		$[2] = t2;
	} else t2 = $[2];
	t1 = t2;
	const hashtagMentionTypeaheadOptions = t1;
	let t3;
	if ($[3] !== editor) {
		t3 = (selectedOption, nodeToReplace, closeMenu) => {
			editor.update(() => {
				const hashtagMentionNode = $createHashtagMentionNode({
					id: selectedOption.key,
					title: selectedOption.title,
					type: selectedOption.type,
					meeting: selectedOption.meeting
				});
				if (nodeToReplace) {
					nodeToReplace.replace(hashtagMentionNode);
					const nodeSelection = $createNodeSelection();
					nodeSelection.add(hashtagMentionNode.getKey());
					$setSelection(nodeSelection);
				}
				closeMenu();
			});
		};
		$[3] = editor;
		$[4] = t3;
	} else t3 = $[4];
	const onSelectOption = t3;
	let t4;
	let t5;
	if ($[5] !== editor) {
		t4 = () => editor.registerCommand(INSERT_HASHTAG_MENTION, _temp2, COMMAND_PRIORITY_CRITICAL);
		t5 = [editor];
		$[5] = editor;
		$[6] = t4;
		$[7] = t5;
	} else {
		t4 = $[6];
		t5 = $[7];
	}
	React$1.useEffect(t4, t5);
	let t6;
	if ($[8] !== hashtagMentionTypeaheadOptions || $[9] !== query) {
		t6 = (anchorElementRef, t7$1) => {
			const { selectOptionAndCleanUp, selectedIndex, setHighlightedIndex } = t7$1;
			return anchorElementRef.current && ReactDOM.createPortal(/* @__PURE__ */ jsx(MentionsFloatingBox, {
				anchor: anchorElementRef.current,
				children: /* @__PURE__ */ jsx(HashtagMentionsOptionsDropdown, {
					query: query ?? "",
					options: hashtagMentionTypeaheadOptions,
					selectOptionAndCleanUp,
					selectedIndex,
					setHighlightedIndex
				})
			}), anchorElementRef.current);
		};
		$[8] = hashtagMentionTypeaheadOptions;
		$[9] = query;
		$[10] = t6;
	} else t6 = $[10];
	let t7;
	if ($[11] !== hashtagMentionTypeaheadOptions || $[12] !== lockScroll || $[13] !== onSelectOption || $[14] !== t6 || $[15] !== unLockScroll) {
		t7 = /* @__PURE__ */ jsx(LexicalTypeaheadMenuPlugin, {
			onQueryChange: setQuery,
			triggerFn: getMaybeQueryMatch,
			options: hashtagMentionTypeaheadOptions,
			onSelectOption,
			onOpen: lockScroll,
			onClose: unLockScroll,
			commandPriority: COMMAND_PRIORITY_NORMAL,
			menuRenderFn: t6
		});
		$[11] = hashtagMentionTypeaheadOptions;
		$[12] = lockScroll;
		$[13] = onSelectOption;
		$[14] = t6;
		$[15] = unLockScroll;
		$[16] = t7;
	} else t7 = $[16];
	return t7;
};
function _temp(option, index) {
	return new HashtagMentionTypeaheadOption(option._id, option.title, isGroupOption(option) ? option.groupType : option.type, index, option.meeting ?? null);
}
function _temp2() {
	const textNodeWithHashtag = insertTextAfterSelection("#");
	if (textNodeWithHashtag == null) return false;
	textNodeWithHashtag.select();
	return true;
}

//#endregion
export { HashtagMentionsPlugin };
//# sourceMappingURL=HashtagMentionsPlugin.js.map